import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';

export const Table = styled('table')`
  border-collapse: collapse;
`;

export const Row = styled('tr')`
  text-align: left;

  &:nth-of-type(2n + 3) {
    background-color: #f1f1f1;
  }
`;

export const HeaderCell = styled('th')`
  padding: ${pxToRem(8)};
  text-align: left;
`;

export const Cell = styled('td')`
  padding: ${pxToRem(8)};

  p {
    padding-top: 0 !important;
  }
`;

export const Paragraph = styled('p')`
  &:not(:first-of-type) {
    padding-top: ${pxToRem(16)};
  }
`;
